import React, {useState, useEffect} from 'react';
import { Textfield } from './textField';
//import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import {updateContactData} from '../store/actions/main';
import SendIcon from '@material-ui/icons/Send';
import Checkbox from '@material-ui/core/Checkbox';

//import axios from 'axios';

const Kontaktformular = props => {
    let [error_gender, setError_gender] = useState(false);
    let [helperText_gender, setHelperText_gender] = useState('');
    let [gender, setGender] = useState('');
    let [firstName, setFirstName] = useState('');
    let [lastName, setLastName] = useState('');
    let [email, setEmail] = useState('');
    let [phone, setPhone] = useState('');
    let [street, setStreet] = useState('');
    let [street_number, setStreetNumber] = useState('');
    let [descriptionData, setDescriptionData] = useState('');
    let [plz, setPlz] = useState('');
    let [place, setPlace] = useState('');
    let [isSendSuccess, setIsSendSuccess] = useState(false);
    let [badSendSuccess, setBadSendSuccess] = useState(false);
    let zaunData = [];
    let fluegelTorData = [];
    let schiebeTorData = [];
    let pforteData = [];
    let stahlGelaenderData = [];
    let edelstahlGelaenderData = [];
    let glas_edelstahlGelaenderData = [];
    let edelstahlGelaenderOhneFuellungData = [];
    let glasvordachFreitragend = [];
    let glasvordachTrave = [];
    let glasvordachZugstangen = [];
    let glasvordachPfosten = [];
    let stahltreppe = [];
    let [agb, setAgb] = useState(false);

    zaunData = props.zaun_data;
    schiebeTorData = props.tore_data[0];
    fluegelTorData = props.tore_data[1];
    pforteData = props.pforten_data;
    stahlGelaenderData = props.gelaender_data[0];
    edelstahlGelaenderData = props.gelaender_data[1];
    glas_edelstahlGelaenderData = props.gelaender_data[2];
    edelstahlGelaenderOhneFuellungData = props.gelaender_data[3];
    glasvordachFreitragend = props.vordaecher_data[0];
    glasvordachTrave = props.vordaecher_data[1];
    glasvordachZugstangen = props.vordaecher_data[2];
    glasvordachPfosten = props.vordaecher_data[3];
    stahltreppe = props.stahltreppen_data;

    useEffect(() => {
        updateContactData();
    })

    const updateValidationErrors = () => {

          if (!gender) {
            setError_gender(true);
            setHelperText_gender('Bitte Anrede auswählen!');
          } else {
            setError_gender(false);
            setHelperText_gender('');
          }

    }

    const updateContactData = () => {
        setGender(props.contactData.gender);
        setFirstName(props.contactData.firstName);
        setLastName(props.contactData.lastName);
        setEmail(props.contactData.email);
        setPhone(props.contactData.phone);
        setStreet(props.contactData.street);
        setStreetNumber(props.contactData.street_number);
        setPlz(props.contactData.plz);
        setPlace(props.contactData.place);
        setDescriptionData(props.contactData.description)
    }


    const submitData = ev => {
        ev.preventDefault();
        updateValidationErrors();

        if (!gender&&!agb) return;

        let products = [
                        zaunData,
                        schiebeTorData,
                        fluegelTorData,
                        pforteData,
                        stahlGelaenderData,
                        edelstahlGelaenderData,
                        glas_edelstahlGelaenderData,
                        edelstahlGelaenderOhneFuellungData,
                        glasvordachFreitragend,
                        glasvordachTrave,
                        glasvordachZugstangen,
                        glasvordachPfosten,
                        stahltreppe
                ];

        let productData = [];
        let mailtext = [];

        let zaunFile = null;
        let fluegelTorFile = null;
        let schiebetorFile = null;
        let pforteFile = null;
        let stahlGelaenderFile = null;
        let edelstahlGelaenderFile = null;
        let glasGelaenderFile = null;
        let handlaufEdelstahlFile = null;
        let glasvordachFreitragendFile = null;
        let glasvordachTraveFile = null;
        let glasvordachZugstangenFile = null;
        let glasvordachPfostenFile = null;
        let stahltreppeFile = null;

        let formdata = new FormData();

        products.forEach((elem, index) => {
             //console.log('elems', elem);
            if (elem.is_merkliste) {
                productData.push(elem);
            }
        });


        productData.forEach((elem, index) => {

             switch(elem.category) {
                case 'Zaun':
                    if (elem.data_description[0].isUploadData) zaunFile = elem.data_description[0].file;
                    mailtext.push('\n');
                    mailtext.push(`ZAUN`);
                    mailtext.push(`- Muster: ${elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}`);
                    mailtext.push(elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?`- Form: ${elem.modell[0].form}`:'');
                    mailtext.push(`- Höhe: ${elem.dimensions[0].total_dimension_height}cm`);
                    mailtext.push(elem.dimensions[0].dimension === 'Gesamt'?`- Gesamtlänge: ${elem.dimensions[0].total_dimension_width}m`:'');
                    mailtext.push(elem.dimensions[0].dimension === 'Einzeln'?`- Zaunfeld 1: (Länge: ${elem.dimensions[0].single_width}cm`:'');
                    mailtext.push(elem.dimensions[0].dimension === 'Einzeln'?`Stückzahl: ${elem.dimensions[0].single_piece})`:'');
                    elem.dimensions[0].single_fields.map((field, field_index) => (
                        mailtext.push( elem.dimensions[0].kind_dimension === 'Die Elemente sind unterschiedlich breit'?`- Zaunfeld ${field_index+2}: (Länge: ${field.width}cm, Stückzahl: ${field.piece})`:'')
                    ));
                    mailtext.push(`- Oberfläche: ${elem.colors[0].kind_of_color === 'Nur feuerverzinkt'? 'Nur feuerverzinkt' : elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}`);
                    mailtext.push(`- Zaunspitzen: ${elem.spitzen[0].spitze}`);
                    mailtext.push(`- Pfosten: ${elem.pfosten[0].ispfosten?'Keine Pfosten':'(Kappe: '+elem.pfosten[0].kappe+', Breite: '+elem.pfosten[0].pfosten_width+'mm)'}`);
                    mailtext.push(elem.data_description[0].description?`- Anmerkungen: ${elem.data_description[0].description}`:'');
                break;
                case 'Flügeltor':
                    if (elem.data_description[0].isUploadData) fluegelTorFile = elem.data_description[0].file;
                    mailtext.push('\n');
                    mailtext.push(`FLÜGELTOR `);
                    mailtext.push(`- Muster: ${elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}`);
                    mailtext.push(elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?`- Form: ${elem.modell[0].form}`:'');
                    mailtext.push(`- Höhe: ${elem.dimensions[0].height}cm`);
                    mailtext.push(`- Gesamtlänge: ${elem.dimensions[0].width}cm`);
                    mailtext.push(`- Oberfläche: ${elem.colors[0].kind_of_color === 'Nur feuerverzinkt'? 'Nur feuerverzinkt' : elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}`);
                    mailtext.push(`- Zaunspitzen: ${elem.spitzen[0].spitze}`);
                    mailtext.push(`- Pfosten: (${elem.pfosten[0].ispfosten?'Keine Pfosten':'Kappe: '+elem.pfosten[0].kappe+', Breite: '+elem.pfosten[0].pfosten_width+'mm'})`);
                    mailtext.push(`- Antrieb: ${elem.antrieb}`);
                    mailtext.push(`- Öffnungsrichtung: ${elem.direction}`);
                    mailtext.push(elem.data_description[0].description?`- Anmerkungen: ${elem.data_description[0].description}`:'');
                break;
                case 'Schiebetor':
                    if (elem.data_description[0].isUploadData) schiebetorFile = elem.data_description[0].file;
                    mailtext.push('\n');
                    mailtext.push(`SCHIEBETOR`);
                    mailtext.push(`- Muster: ${elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}`);
                    mailtext.push(elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?`- Form: ${elem.modell[0].form}`:'');
                    mailtext.push(`- Höhe: ${elem.dimensions[0].height}cm`);
                    mailtext.push(`- Gesamtlänge: ${elem.dimensions[0].width}cm`);
                    mailtext.push(`- Oberfläche: ${elem.colors[0].kind_of_color === 'Nur feuerverzinkt'? 'Nur feuerverzinkt' : elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}`);
                    mailtext.push(`- Zaunspitzen: ${elem.spitzen[0].spitze}`);
                    mailtext.push(`- Pfosten: (${elem.pfosten[0].ispfosten?'Keine Pfosten':'Kappe: '+elem.pfosten[0].kappe+', Breite: '+elem.pfosten[0].pfosten_width+'mm'})`);
                    mailtext.push(`- Antrieb: ${elem.antrieb}`);
                    mailtext.push(`- Öffnungsrichtung: ${elem.direction}`);
                    mailtext.push(elem.data_description[0].description?`- Anmerkungen: ${elem.data_description[0].description}`:'');
                break;
                case 'Pforte':
                    if (elem.data_description[0].isUploadData) pforteFile = elem.data_description[0].file;
                    mailtext.push('\n');
                    mailtext.push(`PFORTE`);
                    mailtext.push(`- Muster: ${elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}`);
                    mailtext.push(elem.modell[0].muster === 'Sortiment'&&elem.modell[0].img?`- Form: ${elem.modell[0].form}`:'');
                    mailtext.push(`- Höhe: ${elem.dimensions[0].height}cm`);
                    mailtext.push(`- Gesamtlänge: ${elem.dimensions[0].width}cm`);
                    mailtext.push(`- Oberfläche: ${elem.colors[0].kind_of_color === 'Nur feuerverzinkt'? 'Nur feuerverzinkt' : elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}`);
                    mailtext.push(`- Zaunspitzen: ${elem.spitzen[0].spitze}`);
                    mailtext.push(`- Pfosten: (${elem.pfosten[0].ispfosten?'Keine Pfosten':'Kappe: '+elem.pfosten[0].kappe+', Breite: '+elem.pfosten[0].pfosten_width+'mm'})`);
                    mailtext.push(`- Öffnungsrichtung: ${elem.direction}`);
                    mailtext.push(elem.data_description[0].description?`- Anmerkungen: ${elem.data_description[0].description}`:'');
                break;
                case 'Stahlgeländer':
                    if (elem.data_description[0].isUploadData) stahlGelaenderFile = elem.data_description[0].file;
                    mailtext.push('\n');
                    mailtext.push(`STAHLGELÄNDER`);
                    mailtext.push(`- Muster: ${elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}`);
                    mailtext.push(`- Grundriss: ${elem.layout}`);
                    mailtext.push(`- Höhe: ${elem.dimensions[0].height}cm`);
                    mailtext.push(
                                elem.dimensions[0].kind_dimension === 'Gesamt'?`- Gesamtlänge: ${elem.dimensions[0].width_total}m`
                                :
                                elem.layout === 'I-Form'?`- Länge des Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm`:''
                                +elem.layout === 'L-Form'?`- Länge des 1. Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm, Länge des 2. Elements: ${elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm, (Gesamtlänge: ${elem.dimensions[0].width_total}cm)`:''
                                +elem.layout === 'U-Form'?`- Länge des 1. Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm, Länge des 2. Elements: ${elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm, Länge des 3. Elements: ${elem.dimensions[0].width_3 > 0? elem.dimensions[0].width_3:'0'}cm, (Gesamtlänge: ${elem.dimensions[0].width_total}cm)`:''
                                +elem.layout === 'Sonderform'?`- Länge des 1. Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm, Länge des 2. Elements: ${elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm, Länge des 3. Elements: ${elem.dimensions[0].width_3 > 0? elem.dimensions[0].width_3:'0'}cm,
                                                          ${stahlGelaenderData.dimensions[0].single_elements.length > 0?
                                                              stahlGelaenderData.dimensions[0].single_elements.map((field, field_index) => (
                                                                  `<span key=${field_index}> Länge des ${field_index+4}. Elements: ${field.width}cm </span>`
                                                              ))
                                                              :''
                                                          }(Gesamtlänge: ${elem.dimensions[0].width_total}cm)`:''
                                )
                    mailtext.push(`- Form des Handlaufs: ${elem.form_handrail[0].handtrail_form}`);
                    mailtext.push(`- Endkappe: ${elem.form_handrail[0].endkappe}`);
                    mailtext.push(`- Form der Pfosten: ${elem.pfosten_form}`);
                    mailtext.push(`- Oberfläche: ${elem.colors[0].kind_of_color === 'Nur feuerverzinkt' || elem.colors[0].kind_of_color === 'Keine Beschichtung'?
                    elem.colors[0].kind_of_color : elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}`);
                    mailtext.push(`- Befestigungsart: ${elem.befestigungsart}`);
                    mailtext.push(elem.data_description[0].description?`- Anmerkungen: ${elem.data_description[0].description}`:'');
                break;
                case 'Edelstahlgeländer':
                    if (elem.data_description[0].isUploadData) edelstahlGelaenderFile = elem.data_description[0].file;
                    mailtext.push('\n');
                    mailtext.push(`EDELSTAHLGELÄNDER`);
                    mailtext.push(`- Muster: ${elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}`);
                    mailtext.push(`- Grundriss: ${elem.layout}`);
                    mailtext.push(`- Höhe: ${elem.dimensions[0].height}cm`);
                    mailtext.push(
                                elem.dimensions[0].kind_dimension === 'Gesamt'?`- Gesamtlänge: ${elem.dimensions[0].width_total}m`
                                :
                                elem.layout === 'I-Form'?`- Länge des Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm`:''
                                +elem.layout === 'L-Form'?`- Länge des 1. Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm, Länge des 2. Elements: ${elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm, (Gesamtlänge: ${elem.dimensions[0].width_total}cm)`:''
                                +elem.layout === 'U-Form'?`- Länge des 1. Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm, Länge des 2. Elements: ${elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm, Länge des 3. Elements: ${elem.dimensions[0].width_3 > 0? elem.dimensions[0].width_3:'0'}cm, (Gesamtlänge: ${elem.dimensions[0].width_total}cm)`:''
                                +elem.layout === 'Sonderform'?`- Länge des 1. Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm, Länge des 2. Elements: ${elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm, Länge des 3. Elements: ${elem.dimensions[0].width_3 > 0? elem.dimensions[0].width_3:'0'}cm,
                                                          ${stahlGelaenderData.dimensions[0].single_elements.length > 0?
                                                              stahlGelaenderData.dimensions[0].single_elements.map((field, field_index) => (
                                                                  `<span key=${field_index}> Länge des ${field_index+4}. Elements: ${field.width}cm </span>`
                                                              ))
                                                              :''
                                                          }(Gesamtlänge: ${elem.dimensions[0].width_total}cm)`:''
                                )
                    mailtext.push(`- Form des Handlaufs: ${elem.form_handrail[0].handtrail_form}`);
                    mailtext.push(`- Endkappe: ${elem.form_handrail[0].endkappe}`);
                    mailtext.push(`- Form der Pfosten: ${elem.pfosten_form}`);
                    mailtext.push(`- Befestigungsart: ${elem.befestigungsart}`);
                    mailtext.push(elem.data_description[0].description?`- Anmerkungen: ${elem.data_description[0].description}`:'');
                break;
                case 'Geländer mit Glas':
                    if (elem.data_description[0].isUploadData) glasGelaenderFile = elem.data_description[0].file;
                    mailtext.push('\n');
                    mailtext.push(`GELÄNDER MIT GLAS`);
                    mailtext.push(`- Muster: ${elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}`);
                    mailtext.push(`- Grundriss: ${elem.layout}`);
                    mailtext.push(`- Höhe: ${elem.dimensions[0].height}cm`);
                    mailtext.push(
                                elem.dimensions[0].kind_dimension === 'Gesamt'?`- Gesamtlänge: ${elem.dimensions[0].width_total}m`
                                :
                                elem.layout === 'I-Form'?`- Länge des Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm`:''
                                +elem.layout === 'L-Form'?`- Länge des 1. Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm, Länge des 2. Elements: ${elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm, (Gesamtlänge: ${elem.dimensions[0].width_total}cm)`:''
                                +elem.layout === 'U-Form'?`- Länge des 1. Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm, Länge des 2. Elements: ${elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm, Länge des 3. Elements: ${elem.dimensions[0].width_3 > 0? elem.dimensions[0].width_3:'0'}cm, (Gesamtlänge: ${elem.dimensions[0].width_total}cm)`:''
                                +elem.layout === 'Sonderform'?`- Länge des 1. Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm, Länge des 2. Elements: ${elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm, Länge des 3. Elements: ${elem.dimensions[0].width_3 > 0? elem.dimensions[0].width_3:'0'}cm,
                                                          ${stahlGelaenderData.dimensions[0].single_elements.length > 0?
                                                              stahlGelaenderData.dimensions[0].single_elements.map((field, field_index) => (
                                                                  `<span key=${field_index}> Länge des ${field_index+4}. Elements: ${field.width}cm </span>`
                                                              ))
                                                              :''
                                                          }(Gesamtlänge: ${elem.dimensions[0].width_total}cm)`:''
                                )
                                mailtext.push(`- Oberfläche: ${elem.colors[0].kind_of_color === 'Nur feuerverzinkt' || elem.colors[0].kind_of_color === 'Keine Beschichtung'?
                                elem.colors[0].kind_of_color : elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}`);
                    mailtext.push(`- Form des Handlaufs: ${elem.form_handrail[0].handtrail_form}`);
                    mailtext.push(`- Endkappe: ${elem.form_handrail[0].endkappe}`);
                    mailtext.push(`- Form der Pfosten: ${elem.pfosten_form}`);
                    mailtext.push(`- Befestigungsart: ${elem.befestigungsart}`);
                    mailtext.push(elem.data_description[0].description?`- Anmerkungen: ${elem.data_description[0].description}`:'');
                break;
                case 'Treppengeländer Edelstahl':
                    if (elem.data_description[0].isUploadData) handlaufEdelstahlFile = elem.data_description[0].file;
                    mailtext.push('\n');
                    mailtext.push(`TREPPENHANDLAUF EDELSTAHL`);
                    mailtext.push(`- Muster: ${elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}`);
                    mailtext.push(`- Grundriss: ${elem.layout}`);
                    mailtext.push(`- Höhe: ${elem.dimensions[0].height}cm`);
                    mailtext.push(
                                elem.dimensions[0].kind_dimension === 'Gesamt'?`- Gesamtlänge: ${elem.dimensions[0].width_total}m`
                                :
                                elem.layout === 'I-Form'?`- Länge des Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm`:''
                                +elem.layout === 'L-Form'?`- Länge des 1. Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm, Länge des 2. Elements: ${elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm, (Gesamtlänge: ${elem.dimensions[0].width_total}cm)`:''
                                +elem.layout === 'U-Form'?`- Länge des 1. Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm, Länge des 2. Elements: ${elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm, Länge des 3. Elements: ${elem.dimensions[0].width_3 > 0? elem.dimensions[0].width_3:'0'}cm, (Gesamtlänge: ${elem.dimensions[0].width_total}cm)`:''
                                +elem.layout === 'Sonderform'?`- Länge des 1. Elements: ${elem.dimensions[0].width_1 > 0? elem.dimensions[0].width_1:'0'}cm, Länge des 2. Elements: ${elem.dimensions[0].width_2 > 0? elem.dimensions[0].width_2:'0'}cm, Länge des 3. Elements: ${elem.dimensions[0].width_3 > 0? elem.dimensions[0].width_3:'0'}cm,
                                                          ${stahlGelaenderData.dimensions[0].single_elements.length > 0?
                                                              stahlGelaenderData.dimensions[0].single_elements.map((field, field_index) => (
                                                                  `<span key=${field_index}> Länge des ${field_index+4}. Elements: ${field.width}cm </span>`
                                                              ))
                                                              :''
                                                          }(Gesamtlänge: ${elem.dimensions[0].width_total}cm)`:''
                                )
                                mailtext.push(`- Oberfläche: ${elem.colors[0].color?elem.colors[0].color:elem.colors[0].kindOfColor}`);
                    mailtext.push(`- Form des Handlaufs: ${elem.form_handrail[0].handtrail_form}`);
                    mailtext.push(`- Endkappe: ${elem.form_handrail[0].endkappe}`);
                    mailtext.push(`- Form der Pfosten: ${elem.pfosten_form}`);
                    mailtext.push(`- Befestigungsart: ${elem.befestigungsart}`);
                    mailtext.push(elem.data_description[0].description?`- Anmerkungen: ${elem.data_description[0].description}`:'');
                break;
                case 'Glasvordach freitragend':
                    if (elem.data_description[0].isUploadData) glasvordachFreitragendFile = elem.data_description[0].file;
                    mailtext.push('\n');
                    mailtext.push(`GLASVORDACH FREITRAGEND`);
                    mailtext.push(`- Breite: ${elem.dimensions[0].width}cm`);
                    mailtext.push(`- Höhe: ${elem.dimensions[0].height}cm`);
                    mailtext.push(`- Glastönung: ${elem.glasart}`);
                    mailtext.push(elem.data_description[0].description?`- Anmerkungen: ${elem.data_description[0].description}`:'');
                break;
                case 'Glasvordach Trave':
                    if (elem.data_description[0].isUploadData) glasvordachTraveFile = elem.data_description[0].file;
                    mailtext.push('\n');
                    mailtext.push(`GLASVORDACH TRAVE`);
                    mailtext.push(`- Breite: ${elem.dimensions[0].width}cm`);
                    mailtext.push(`- Höhe: ${elem.dimensions[0].height}cm`);
                    mailtext.push(`- Glastönung: ${elem.glasart}`);
                    mailtext.push(elem.data_description[0].description?`- Anmerkungen: ${elem.data_description[0].description}`:'');
                break;
                case 'Glasvordach mit Zugstangen':
                    if (elem.data_description[0].isUploadData) glasvordachZugstangenFile = elem.data_description[0].file;
                    mailtext.push('\n');
                    mailtext.push(`GLASVORDACH MIT ZUGSTANGEN`);
                    mailtext.push(`- Breite: ${elem.dimensions[0].width}cm`);
                    mailtext.push(`- Höhe: ${elem.dimensions[0].height}cm`);
                    mailtext.push(`- Glastönung: ${elem.glasart}`);
                    mailtext.push(elem.data_description[0].description?`- Anmerkungen: ${elem.data_description[0].description}`:'');
                break;
                case 'Glasvordach mit Pfosten':
                    if (elem.data_description[0].isUploadData) glasvordachPfostenFile = elem.data_description[0].file;
                    mailtext.push('\n');
                    mailtext.push(`GLASVORDACH MIT PFOSTEN`);
                    mailtext.push(`- Breite: ${elem.dimensions[0].width}cm`);
                    mailtext.push(`- Höhe: ${elem.dimensions[0].height}cm`);
                    mailtext.push(elem.titel === 'Glasvordach mit Pfosten'?`- Pfosten: ${elem.pfosten}`:'');
                    mailtext.push(`- Glastönung: ${elem.glasart}`);
                    mailtext.push(elem.data_description[0].description?`- Anmerkungen: ${elem.data_description[0].description}`:'');
                break;
                case 'Stahltreppe':
                    if (elem.data_description[0].isUploadData) stahltreppeFile = elem.data_description[0].file;
                    mailtext.push('\n');
                    mailtext.push(`STAHLTREPPE`);
                    mailtext.push(`- Muster für Geländer: ${elem.modell[0].muster === 'Sortiment'&&elem.modell[0].titel?elem.modell[0].titel:'Eigenes Muster'}`);
                    // mailtext.push(`- Endkappe des Handlaufs: ${elem.handlauf[0].endkappe}`);
                    mailtext.push(`- Geschosshöhe: ${elem.geschosshoehe[0].height}cm ${elem.geschosshoehe[0].height>=83?`(Stufen: ${elem.geschosshoehe[0].stufen} St.)`:''} `);
                    mailtext.push(`- Breite der Stufen: ${elem.stufenBreite}`);
                    mailtext.push(elem.podest[0].isPodest === 'nein'?`- Podest: Kein Podest`:`- Podestlänge: ${elem.podest[0].podestWidth}cm`);
                    mailtext.push(`- Oberfläche: ${elem.colors[0].kind_of_color === 'Nur feuerverzinkt'? 'Nur feuerverzinkt' : elem.colors[0].kind_of_color + ' ('+elem.colors[0].color+')'}`);
                    mailtext.push(elem.data_description[0].description?`- Anmerkungen: ${elem.data_description[0].description}`:'');
                break;
                default:
                    return elem.category;
             }

        });

        mailtext = mailtext.filter(elem => elem !== '');

        let products_data = [];

        for (let i = 0; i < mailtext.length; i++) {
            products_data.push(mailtext[i]+'\n');
        }

        console.log('products_data', products_data);

        products_data = products_data.join(" ");

        //let url = 'http://localhost:5000';
        //let url = 'https://apimkhausservice.herokuapp.com/';
        let url = 'https://www.metalltechnik-hamburg.de/api/wordpress/wp-json/contact-form-7/v1/contact-forms/5/feedback';

        formdata.append('gender', gender);
        formdata.append('firstName', firstName);
        formdata.append('lastName', lastName);
        formdata.append('email', email);
        formdata.append('phone', phone);
        formdata.append('street', street);
        formdata.append('street_number', street_number);
        formdata.append('plz', plz);
        formdata.append('place', place);
        formdata.append('yourMessage', descriptionData?descriptionData:null);
        formdata.append('yourSubject', 'Anfrage von Konfigurator');
        formdata.append('briefkasten',  props.briefkasten);
        formdata.append('products', products_data);
        //Files
        if (zaunFile) formdata.append('zaunFile', zaunFile);
        if (fluegelTorFile) formdata.append('fluegelTorFile', fluegelTorFile);
        if (schiebetorFile) formdata.append('schiebetorFile', schiebetorFile);
        if (pforteFile) formdata.append('pforteFile', pforteFile);
        if (stahlGelaenderFile) formdata.append('stahlGelaenderFile', stahlGelaenderFile);
        if (edelstahlGelaenderFile) formdata.append('edelstahlGelaenderFile', edelstahlGelaenderFile);
        if (glasGelaenderFile) formdata.append('glasGelaender', glasGelaenderFile);
        if (handlaufEdelstahlFile) formdata.append('handlaufEdelstahlFile', handlaufEdelstahlFile);
        if (glasvordachFreitragendFile) formdata.append('glasvordachFreitragendFile', glasvordachFreitragendFile);
        if (glasvordachTraveFile) formdata.append('glasvordachTraveFile', glasvordachTraveFile);
        if (glasvordachZugstangenFile) formdata.append('glasvordachZugstangenFile', glasvordachZugstangenFile);
        if (glasvordachPfostenFile) formdata.append('glasvordachPfostenFile', glasvordachPfostenFile);
        if (stahltreppeFile) formdata.append('stahltreppeFile', stahltreppeFile);

        console.log('POSTDATA', formdata);

        for (var entrie of formdata.entries()) {
            console.log('Value of Data', entrie);
        }

        let fetchData = () => fetch(url, {
            method : "POST",
            body: formdata
        })
        .then(res => {
            console.log('response', res);
            if (res.status === 200 && res.ok === true) {
                setIsSendSuccess(true);
                setTimeout(()=> {
                    setIsSendSuccess(false);
                },7000);
            }
            if (res.status !== 200 && res.ok === false) {
                setBadSendSuccess(true);
                setTimeout(()=> {
                    setBadSendSuccess(false);
                },7000);
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });

        fetchData();

        // function readFileAsText(file,category){

        //     let fr = new FileReader();

        //     fr.onerror = function(){
        //        console.log(fr);
        //     };

        //         fr.onload = function(){
        //             switch (category) {
        //                 case 'zaun':
        //                     formDataZaun = fr.result;
        //                 break;
        //                 case 'flügeltor':
        //                     formDataFluegeltor = fr.result;
        //                 break;
        //                 case 'schiebetor':
        //                     formDataSchiebetor = fr.result;
        //                 break;
        //                 case 'pforte':
        //                     formDataPforte = fr.result;
        //                 break;
        //                 case 'stahlgeländer':
        //                     formDataStahlGelaender = fr.result;
        //                 break;
        //                 case 'edelstahlgeländer':
        //                     formDataEdelstahlGelaender = fr.result;
        //                 break;
        //                 case 'geländer mit glas':
        //                     formDataGelaenderMitGlas = fr.result;
        //                 break;
        //                 case 'treppenhandlauf edelstahl':
        //                     formDataTreppenHandlaufEdelstahl = fr.result;
        //                 break;
        //                 case 'glasvordach freitragend':
        //                     formDataGlasvordachFreitragend = fr.result;
        //                 break;
        //                 case 'glasvordach trave':
        //                     formDataGlasvordachTrave = fr.result;
        //                 break;
        //                 case 'glasvordach zugstangen':
        //                     formDataGlasvordachZugstangen = fr.result;
        //                 break;
        //                 case 'glasvordach pfosten':
        //                     formDataGlasvordachPfosten = fr.result;
        //                 break;
        //                 case 'stahltreppe':
        //                     formDataStahltreppe = fr.result;
        //                 break;
        //                 default:
        //                     return category;
        //             }


        //             fetchData();
        //         };
        //     fr.readAsDataURL(file);
        // };


        // if (!isFileUpload) {
        //     fetchData();
        // }

    }

    const selectItems = ev => {
        let name = ev.currentTarget.getAttribute('name');
        let value = ev.target.value;
        let contactObject = {
            name: name,
            value: value
        }
        props.updateContactData(contactObject);
        updateContactData();
    }

    const updateAgb = () => setAgb(!agb);

    const gender_options = [
        {titel: 'Frau'},
        {titel: 'Herr'}
    ];


    return (
        <form className='kontaktformular' onSubmit={submitData}>
                <Textfield
                     required
                     error={error_gender}
                     helperText={helperText_gender}
                     label="Anrede"
                     select
                     type="text"
                     name='gender'
                     rowsMax={1}
                     value={gender}
                     onChange={selectItems}
                     array_options={gender_options}
                />
            <div className='textfield_wrapper'>
                <Textfield
                    required
                    label='Vorname'
                    type='text'
                    name='firstname'
                    rowsMax={1}
                    value={firstName}
                    onChange={selectItems}
                />
                <Textfield
                    required
                    label='Nachname'
                    type='text'
                    name='lastname'
                    rowsMax={1}
                    value={lastName}
                    onChange={selectItems}
                />
            </div>
            <div className='textfield_wrapper'>
                <Textfield
                    required
                    label='Email'
                    type='text'
                    name='email'
                    rowsMax={1}
                    value={email}
                    onChange={selectItems}
                />
                <Textfield
                    label='Telefon'
                    type='text'
                    name='phone'
                    rowsMax={1}
                    value={phone}
                    onChange={selectItems}
                />
            </div>
            <div className='textfield_wrapper'>
                <Textfield
                    label='Straße'
                    type='text'
                    name='street'
                    rowsMax={1}
                    value={street}
                    onChange={selectItems}
                />
                <Textfield
                    label='Nr'
                    type='text'
                    name='street_number'
                    rowsMax={1}
                    value={street_number}
                    onChange={selectItems}
                />
            </div>
            <div className='textfield_wrapper'>
                <Textfield
                    label='PLZ'
                    type='text'
                    name='plz'
                    rowsMax={1}
                    value={plz}
                    onChange={selectItems}
                />
                <Textfield
                    label='Ort'
                    type='text'
                    name='place'
                    rowsMax={1}
                    value={place}
                    onChange={selectItems}
                />
            </div>
            <div className='agb-wrapper'>
                <Checkbox
                    required
                    value={agb}
                    onChange={updateAgb}
                    className='agb'
                />
                <span>Ich habe&nbsp;
                    {/* die  <a href="https://www.metalltechnik-hamburg.de/agb.html" target='blank'>AGB</a> sowie  */}
                     die  <a href="https://www.metalltechnik-hamburg.de/datenschutz.html" target='blank'>Datenschutzbestimmungen</a>  gelesen und stimme diesen zu.</span>
            </div>

            {/* <TextField
                className="textfield_multiline"
                type="text"
                label="Ihr Anliegen:"
                rowsMax={10}
                multiline
                variant="outlined"
                value={descriptionData}
                name="description"
                onChange={selectItems}
                >
            </TextField> */}
            <Button
                startIcon={<SendIcon />}
                className="button"
                type='submit'
                >Anfrage senden
            </Button>
            {isSendSuccess?
                <div className='success_message'>
                    <h2>Ihre Anfrage wurde erfolgreich versendet!</h2>
                    <p>Wir werden uns in Kürze mit Ihnen in Verbindung setzen.</p>
                </div>
            :''}
            {badSendSuccess?
                 <div className='bad_message'>
                    <h2>Ihre Anfrage konnte leider nicht versendet werden!</h2>
                    <p>Versuchen Sie es zu einem späteren Zeitpunt erneut.</p>
                </div>
            :''}
       </form>
    )
}

const mapStateToProps = state => {
    return {
        //Zäune
        zaun_data: state.zauneReducer.data,
        //Tore
        tore_data: state.toreReducer.data,
        tore_muster: state.toreReducer.muster,
        //Pforten
        pforten_data: state.pfortenReducer.data,
        //Geländer
        gelaender_data: state.gelaenderReducer.data,
        //Vordächer
        vordaecher_data: state.vordaecherReducer.data,
        //Stahltreppen
        stahltreppen_data: state.stahltreppenReducer.data,
        //Contact Data
        contactData: state.mainReducer.contact[0].data[0],
        //Briefkasten
        briefkasten: state.mainReducer.data[0].briefkasten[0].briefkasten_select

    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateContactData: ev => dispatch(updateContactData(ev))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Kontaktformular);